/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface StatParcelAnalysisSum { 
    departmentId?: number;
    id?: number;
    parcelAnalysisSum?: number;
    parcelAnalysisSumOtherBlocks?: number;
    parcelAnalysisSumOurBlocks?: number;
    parcelAnalysisSumOurLpis?: number;
    parcelAnalysisSumOurLpisUntreated?: number;
    parcelAnalysisSumOutsideBlocks?: number;
}

